import { useCallback } from 'react';

const getTestId = (moduleName: string, id?: string): string =>
  `${moduleName}${id ? '.' + id : ''}`;

type Fn = (id?: string) => string;

export const useTestId = (moduleName: string): Fn =>
  useCallback<Fn>((id?: string) => getTestId(moduleName, id), [moduleName]);
